/**
 * @generated SignedSource<<f41721021c92dda83d69c5f3b85fcaba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetailTabs_item$data = {
  readonly attributes: {
    readonly customizable: ReadonlyArray<{
      readonly option: {
        readonly serviceId: string | null;
      } | null;
      readonly text: string | null;
    } | null> | null;
    readonly ringResizable: ReadonlyArray<{
      readonly option: {
        readonly serviceId: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly isCustomizable: boolean | null;
  readonly isDyoCustomizable: boolean | null;
  readonly isListingMigrated: boolean | null;
  readonly seller: {
    readonly isAccessible: boolean | null;
  } | null;
  readonly skus: ReadonlyArray<{
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_sku" | "PdpRespShippingReturns_sku">;
  } | null> | null;
  readonly storyTelling: {
    readonly tabs: ReadonlyArray<{
      readonly tabTitle: string;
      readonly tabType: string;
      readonly " $fragmentSpreads": FragmentRefs<"PdpRespStorytellingTab_storyTellingTab">;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_item" | "PdpRespPricingGuidance_item" | "PdpRespSharedAboutItemPanel_item" | "PdpRespShippingReturns_item" | "PdpRespTabsCustomizationPanel_item" | "PdpSharedEstimateSimilarSoldPricing_item" | "usePdpEstimateSimilarSold_item">;
  readonly " $fragmentType": "PdpRespDetailTabs_item";
};
export type PdpRespDetailTabs_item$key = {
  readonly " $data"?: PdpRespDetailTabs_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetailTabs_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeOption",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": [
    (v0/*: any*/)
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "isEstimateSimilarSoldVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetailTabs_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "skus",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "condition": "isMultiSku",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespDealerDetails_sku"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespShippingReturns_sku"
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "alias": "storyTelling",
      "args": [
        {
          "kind": "Literal",
          "name": "shortTitles",
          "value": true
        }
      ],
      "concreteType": "StoryTellingModule",
      "kind": "LinkedField",
      "name": "storyTellingModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoryTellingTab",
          "kind": "LinkedField",
          "name": "tabs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tabType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tabTitle",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespStorytellingTab_storyTellingTab"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "storyTellingModule(shortTitles:true)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCustomizable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDyoCustomizable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "kind": "LinkedField",
      "name": "attributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "customizable",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "ringResizable",
          "plural": true,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isListingMigrated",
      "storageKey": null
    },
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespPricingGuidance_item"
        }
      ]
    },
    {
      "condition": "isEstimateSimilarSoldVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedEstimateSimilarSoldPricing_item"
            }
          ]
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedAboutItemPanel_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespTabsCustomizationPanel_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePdpEstimateSimilarSold_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "2d244bebe0898306f5a0050a30cfb22f";

export default node;
